import phComponents from "../../web-sh/src/components/page-header";

import Actions from "./Actions";
import WelcomeBanner from "./WelcomeBanner";

phComponents.Actions = Actions;

const pageHeaderComponents = {
  ...phComponents,
  WelcomeBanner
}

export default pageHeaderComponents;